import React, { useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcUserPlus, IcIdCard, IcMap, IcHandshake, IcFileInvoice, IcSave } from "../../Icons";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";

function ClientesCreate() {
  const { user }       = useContext(AuthContext);
  const URL_CLIENTES   = process.env.REACT_APP_URL_CLIENTES;

  const [nombre_comercial,    setNombreComercial]    = useState("NA");
  const [razon_social,        setRazonSocial]        = useState("NA");
  const [RFC,                 setRFC]                = useState("NA");
  const [calle,               setCalle]              = useState("NA");
  const [numero_ext,          setNumeroExt]          = useState("NA");
  const [numero_int,          setNumeroInt]          = useState("NA");
  const [delegacion,          setDelegacion]         = useState("NA");
  const [estado,              setEstado]             = useState("NA");
  const [pais,                setPais]               = useState("Mexico");
  const [cp,                  setCP]                 = useState("NA");
  const [colonia,             setColonia]            = useState("NA");
  const [ciudad,              setCiudad]             = useState("NA");
  const [contacto,            setContacto]           = useState("NA");
  const [telefono,            setTelefono]           = useState("0");
  const [email,               setEmail]              = useState("a@a.c");
  const [observaciones,       setObservaciones]      = useState("NA");
  const [lider,               setLider]              = useState("NA");
  const [ramo,                setRamo]               = useState("");
  const [mes,                 setMes]                = useState("");
  const [anio,                setAnio]               = useState("");
  const [copiadoDe,           setCopiadoDe]          = useState("");
  const [forma_pago,          setFormaPago]          = useState("");
  const [plazo,               setPlazo]              = useState("");
  const [regFiscal,           setRegFiscal]          = useState("");
  const [usoCFDI,             setusoCFDI]            = useState("");
  const [formaPagoSAT,        setFormaPagoSAT]       = useState("");
  const [condicionesPagoSAT,  setCondicionesPagoSAT] = useState("");
  const [metodoPagoSAT,       setMetodoPagoSAT]      = useState("");
  const [validaBoton,         setValidaBoton]        = useState(true);

  const saveClientes = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios.post(URL_CLIENTES, {
        nombre_comercial, razon_social, RFC, calle, numero_ext, numero_int,
        delegacion, estado, pais, cp, colonia, ciudad, contacto, telefono,
        email, observaciones, ultimo_pago: "2022-01-01",
        cargos: 0, abonos: 0, saldo: 0,
        lider, ramo, mes, anio, produccion: "No", copiadoDe, forma_pago, plazo,
        cargosk: 0, abonosk: 0, saldok: 0,
        usoCFDI, regFiscal, formaPagoSAT, condicionesPagoSAT, metodoPagoSAT,
        fiscal: "No",
      }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });

      Swal.fire("¡Listo!", "Cliente creado con éxito", "success");
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      setValidaBoton(true);
    }
  };

  const field = (label, value, setter, type = "text", placeholder = "") => (
    <FormGroup>
      <Label>{label}</Label>
      <Input type={type} value={value} placeholder={placeholder || label}
        onChange={(e) => setter(e.target.value)} required />
    </FormGroup>
  );

  return (
    <>
      <Header />
      <br />
      <div className="card container col-sm-11">

        {/* ── Page header ─────────────────────────────────────────────── */}
        <div className="page-header">
          <div>
            <h3 className="page-title">
              <IcUserPlus style={{ marginRight: 8, color: "#8b5cf6" }} />
              Nuevo Cliente
            </h3>
            <p className="page-subtitle">Completa los datos del cliente para registrarlo en el sistema</p>
          </div>
        </div>

        <Form onSubmit={saveClientes}>

          {/* ── Sección 1: Información principal ──────────────────────── */}
          <div className="form-section">
            <div className="form-section-header">
              <IcIdCard />
              <span className="form-section-title">Información Principal</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={3}>{field("Contacto",        contacto,        setContacto)}</Col>
                <Col md={3}>{field("Nombre Comercial", nombre_comercial, setNombreComercial)}</Col>
                <Col md={3}>{field("Razón Social",     razon_social,    setRazonSocial)}</Col>
                <Col md={3}>{field("RFC",              RFC,             setRFC)}</Col>
              </Row>
              <Row>
                <Col md={3}>{field("Teléfono", telefono, setTelefono)}</Col>
                <Col md={3}>{field("Email",    email,    setEmail, "email")}</Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Ramo</Label>
                    <Input type="select" value={ramo} required onChange={(e) => setRamo(e.target.value)}>
                      <option value="">Selecciona</option>
                      {["Administracion","Despacho","Donativos","Importacion","Logistica",
                        "Market Place","Produccion","Sistema","Telas"].map((r) => (
                        <option key={r} value={r}>{r}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>{field("Observaciones", observaciones, setObservaciones)}</Col>
              </Row>
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label>Mes de Alta</Label>
                    <Input type="select" value={mes} onChange={(e) => setMes(e.target.value)}>
                      <option value="">Selecciona</option>
                      {["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio",
                        "Agosto","Septiembre","Octubre","Noviembre","Diciembre"].map((m) => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Año de Alta</Label>
                    <Input type="select" value={anio} onChange={(e) => setAnio(e.target.value)}>
                      <option value="">Selecciona</option>
                      {["2022","2023","2024","2025","2026","2027","2028","2029","2030","2031"].map((y) => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          {/* ── Sección 2: Dirección ───────────────────────────────────── */}
          <div className="form-section">
            <div className="form-section-header">
              <IcMap />
              <span className="form-section-title">Dirección</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={5}>{field("Calle",      calle,     setCalle)}</Col>
                <Col md={2}>{field("No. Ext",    numero_ext, setNumeroExt)}</Col>
                <Col md={2}>{field("No. Int",    numero_int, setNumeroInt)}</Col>
                <Col md={3}>{field("País",        pais,       setPais)}</Col>
              </Row>
              <Row>
                <Col md={3}>{field("Estado",      estado,     setEstado)}</Col>
                <Col md={3}>{field("Ciudad",      ciudad,     setCiudad)}</Col>
                <Col md={3}>{field("Delegación",  delegacion, setDelegacion)}</Col>
                <Col md={2}>{field("Colonia",     colonia,    setColonia)}</Col>
                <Col md={1}>{field("CP",          cp,         setCP)}</Col>
              </Row>
            </div>
          </div>

          {/* ── Sección 3: Datos comerciales ──────────────────────────── */}
          <div className="form-section">
            <div className="form-section-header">
              <IcHandshake />
              <span className="form-section-title">Datos Comerciales</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={3}>{field("Líder",       lider,     setLider)}</Col>
                <Col md={3}>{field("Copiado de",  copiadoDe, setCopiadoDe)}</Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Forma de Pago</Label>
                    <Input type="select" value={forma_pago} required onChange={(e) => setFormaPago(e.target.value)}>
                      <option value="">Selecciona</option>
                      {["Efectivo","Deposito","Cheque","PorDefinir"].map((f) => (
                        <option key={f} value={f}>{f}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Plazo (días)</Label>
                    <Input type="select" value={plazo} required onChange={(e) => setPlazo(e.target.value)}>
                      <option value="">Selecciona</option>
                      {["0","30","60","90","120","150"].map((p) => (
                        <option key={p} value={p}>{p}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          {/* ── Sección 4: Datos fiscales ──────────────────────────────── */}
          <div className="form-section">
            <div className="form-section-header">
              <IcFileInvoice />
              <span className="form-section-title">Datos Fiscales</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label>Régimen Fiscal</Label>
                    <Input type="select" value={regFiscal} required onChange={(e) => setRegFiscal(e.target.value)}>
                      <option value="">Selecciona</option>
                      <option value="601">601 General de Ley Personas Morales</option>
                      <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                      <option value="605">605 Sueldos y Salarios</option>
                      <option value="608">608 Demás Ingresos</option>
                      <option value="612">612 Personas Físicas con Actividades Empresariales</option>
                      <option value="616">616 Sin Obligación Fiscal</option>
                      <option value="621">621 Incorporación Fiscal</option>
                      <option value="624">624 Régimen de los Coordinados</option>
                      <option value="625">625 Act. emp. con ingresos vía plataformas tec.</option>
                      <option value="626">626 Régimen Simplificado de Confianza</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Uso de CFDI</Label>
                    <Input type="select" value={usoCFDI} required onChange={(e) => setusoCFDI(e.target.value)}>
                      <option value="">Selecciona</option>
                      <option value="G01">G01 Adquisición de mercancías</option>
                      <option value="G03">G03 Gastos en general</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Método de Pago Fiscal</Label>
                    <Input type="select" value={metodoPagoSAT} required onChange={(e) => setMetodoPagoSAT(e.target.value)}>
                      <option value="">Selecciona</option>
                      <option value="PUE">PUE — Pago en Una Sola Exhibición</option>
                      <option value="PPD">PPD — Pago en Parcialidades o Diferido</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Forma de Pago Fiscal (SAT)</Label>
                    <Input type="select" value={formaPagoSAT} required onChange={(e) => setFormaPagoSAT(e.target.value)}>
                      <option value="">Selecciona</option>
                      <option value="01">01 Efectivo</option>
                      <option value="02">02 Cheque nominativo</option>
                      <option value="03">03 Transferencia electrónica</option>
                      <option value="04">04 Tarjeta de crédito</option>
                      <option value="28">28 Tarjeta de débito</option>
                      <option value="99">99 Por definir</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  {field("Condiciones de Pago Fiscal", condicionesPagoSAT, setCondicionesPagoSAT)}
                </Col>
              </Row>
            </div>
          </div>

          {/* ── Submit ─────────────────────────────────────────────────── */}
          <div className="submit-bar">
            <Button type="submit" color="success" disabled={!validaBoton}>
              <IcSave style={{ marginRight: 6 }} />
              Guardar Cliente
            </Button>
          </div>

        </Form>
      </div>
    </>
  );
}

export default ClientesCreate;
